import React, { useState } from "react";
import styles from "./WeddingWallGuest.module.css";
import {
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import img from "../../../assets/staticImages/photoimg1.png";
import img1 from "../../../assets/staticImages/photoimg4.png";
import placeholderImg from "../../../assets/dummy.png";

import dots from "../../../assets/pfdots.png";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GuestMiddleware } from "../../../Store/Middlewares/GuestMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const WeddingWallGuest = () => {
  const eventData = useLocation()?.state?.eventData;
  const EventDetails = useSelector(
    (state) => state?.GuestReducer?.EventDetails
  );
  const [save, setSave] = useState(false);
  const [notes, setNotes] = useState("");

  const dispatch = useDispatch();

  const onSubmitMessage = () => {
    if (!notes) {
      dispatch(
        showAlert({
          message: "Well wishing field is required",
          type: "error",
        })
      );
    } else {
      dispatch(
        GuestMiddleware.createWeddingWall({ event_id: eventData.id, notes })
      );
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.dtlusersImg}>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                eventData?.bride?.image
                  ? eventData?.bride?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <img src={dots} className={styles.dots} />
          </div>
          <TextComponent
            text={eventData?.bride?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Bride"} textClass={styles.role} /> */}
        </div>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                eventData?.groom?.image
                  ? eventData?.groom?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <img src={dots} className={styles.dots} />
          </div>
          <TextComponent
            text={eventData?.groom?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Groom"} textClass={styles.role} /> */}
        </div>
      </div>
      <TextComponent
        text={`Write a well wishing text for ${EventDetails?.groom?.first_name} & ${EventDetails?.bride?.first_name} for there wedding`}
        textClass={styles.desc}
      />
      <TextComponent
        text={`${eventData?.groom?.first_name} & ${eventData?.bride?.first_name}`}
        textClass={styles.BGname}
      />
      <TextComponent text={EventDetails?.name} textClass={styles.category} />
      {!EventDetails?.well_wish ? (
        <>
          <div className={styles.textArea}>
            <TextareaField
              textareaClass={styles.TextareaField}
              rows={6}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder={"Add text here"}
              innerInputClass={styles.forplaceholder}
            />
          </div>
          <div className={styles.submitBtn}>
            <SubmitButton
              btnClass={styles.nextBtn2}
              title={"Save"}
              onClick={() => onSubmitMessage()}
            />
          </div>
        </>
      ) : (
        <TextComponent
          textClass={styles.text}
          text={EventDetails?.well_wish?.note}
        />
      )}
    </div>
  );
};

export default WeddingWallGuest;
